var NavigationLogo = function NavigationLogo(_ref) {
  var app = _ref.app;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "nav-header__logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo.png"
  })), app === 'washplant' && /*#__PURE__*/React.createElement("img", {
    src: "/public/images/wash-plant-logo-nav-blue@3x.png",
    className: "nav-header__logo--washplant"
  }), app === 'materials' && /*#__PURE__*/React.createElement("img", {
    src: "/public/images/posillico-materials-hi-nop.png",
    className: "nav-header__logo--materials"
  }));
};
export default NavigationLogo;